// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Common from "../Restaumatic.PromotionsEngine.Common/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var TargetCart = /* #__PURE__ */ (function () {
    function TargetCart() {

    };
    TargetCart.value = new TargetCart();
    return TargetCart;
})();
var TargetProductItems = /* #__PURE__ */ (function () {
    function TargetProductItems(value0) {
        this.value0 = value0;
    };
    TargetProductItems.create = function (value0) {
        return new TargetProductItems(value0);
    };
    return TargetProductItems;
})();
var NoSource = /* #__PURE__ */ (function () {
    function NoSource() {

    };
    NoSource.value = new NoSource();
    return NoSource;
})();
var SourceProductItems = /* #__PURE__ */ (function () {
    function SourceProductItems(value0) {
        this.value0 = value0;
    };
    SourceProductItems.create = function (value0) {
        return new SourceProductItems(value0);
    };
    return SourceProductItems;
})();
var AssignmentToCart = /* #__PURE__ */ (function () {
    function AssignmentToCart() {

    };
    AssignmentToCart.value = new AssignmentToCart();
    return AssignmentToCart;
})();
var UnassignmentToCart = /* #__PURE__ */ (function () {
    function UnassignmentToCart() {

    };
    UnassignmentToCart.value = new UnassignmentToCart();
    return UnassignmentToCart;
})();
var AssignmentToProduct = /* #__PURE__ */ (function () {
    function AssignmentToProduct(value0) {
        this.value0 = value0;
    };
    AssignmentToProduct.create = function (value0) {
        return new AssignmentToProduct(value0);
    };
    return AssignmentToProduct;
})();
var UnassignmentToProduct = /* #__PURE__ */ (function () {
    function UnassignmentToProduct() {

    };
    UnassignmentToProduct.value = new UnassignmentToProduct();
    return UnassignmentToProduct;
})();
var Percentage = /* #__PURE__ */ (function () {
    function Percentage(value0) {
        this.value0 = value0;
    };
    Percentage.create = function (value0) {
        return new Percentage(value0);
    };
    return Percentage;
})();
var Price = /* #__PURE__ */ (function () {
    function Price(value0) {
        this.value0 = value0;
    };
    Price.create = function (value0) {
        return new Price(value0);
    };
    return Price;
})();
var Coupon = function (x) {
    return x;
};
var FreeProductInput = /* #__PURE__ */ (function () {
    function FreeProductInput(value0) {
        this.value0 = value0;
    };
    FreeProductInput.create = function (value0) {
        return new FreeProductInput(value0);
    };
    return FreeProductInput;
})();
var CouponCodeInput = /* #__PURE__ */ (function () {
    function CouponCodeInput(value0) {
        this.value0 = value0;
    };
    CouponCodeInput.create = function (value0) {
        return new CouponCodeInput(value0);
    };
    return CouponCodeInput;
})();
var NoInput = /* #__PURE__ */ (function () {
    function NoInput() {

    };
    NoInput.value = new NoInput();
    return NoInput;
})();
var AutoEnabled = /* #__PURE__ */ (function () {
    function AutoEnabled() {

    };
    AutoEnabled.value = new AutoEnabled();
    return AutoEnabled;
})();
var AutoDisabled = /* #__PURE__ */ (function () {
    function AutoDisabled() {

    };
    AutoDisabled.value = new AutoDisabled();
    return AutoDisabled;
})();
var UserEnabled = /* #__PURE__ */ (function () {
    function UserEnabled(value0) {
        this.value0 = value0;
    };
    UserEnabled.create = function (value0) {
        return new UserEnabled(value0);
    };
    return UserEnabled;
})();
var UserDisabled = /* #__PURE__ */ (function () {
    function UserDisabled() {

    };
    UserDisabled.value = new UserDisabled();
    return UserDisabled;
})();
var PromotionalItem = function (x) {
    return x;
};
var selectionStatusAge = function (v) {
    if (v instanceof UserEnabled) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var productItemKeysInTarget = function (v) {
    if (v instanceof TargetCart) {
        return Data_Set.empty;
    };
    if (v instanceof TargetProductItems) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 223, column 1 - line 223, column 84): " + [ v.constructor.name ]);
};
var oldenUserEnabledSelectionStatus = function (v) {
    if (v instanceof UserEnabled) {
        return new UserEnabled(Data_Numeric.add(Data_Numeric.additiveInt)(v.value0)(1));
    };
    return v;
};
var newtypePromotionalItem = {
    Coercible0: function () {
        return undefined;
    }
};
var promotion = /* #__PURE__ */ (function () {
    var $224 = Data_Newtype.unwrap();
    return function ($225) {
        return (function (v) {
            return v.promotion;
        })($224($225));
    };
})();
var promotionId = function ($226) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.promotionId(promotion($226));
};
var promotions = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray)(promotion);
var promotionalItemId = /* #__PURE__ */ (function () {
    var $227 = Data_Newtype.unwrap();
    return function ($228) {
        return (function (v) {
            return v.promotionalItemId;
        })($227($228));
    };
})();
var promotionalItemInput = /* #__PURE__ */ (function () {
    var $229 = Data_Newtype.unwrap();
    return function ($230) {
        return (function (v) {
            return v.input;
        })($229($230));
    };
})();
var selectedFreeby = function (promoItem) {
    var v = promotionalItemInput(promoItem);
    if (v instanceof FreeProductInput) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.findPromotionFreeby(v.value0.selection)(promotion(promoItem));
    };
    return Data_Maybe.Nothing.value;
};
var promotionalItemValue = /* #__PURE__ */ (function () {
    var $231 = Data_Newtype.unwrap();
    return function ($232) {
        return (function (v) {
            return v.value;
        })($231($232));
    };
})();
var selection = /* #__PURE__ */ (function () {
    var $233 = Data_Newtype.unwrap();
    return function ($234) {
        return (function (v) {
            return v.selection;
        })($233($234));
    };
})();
var oldenUserSelection = function (promoItem) {
    return Data_Newtype.wrap()((function () {
        var v = Data_Newtype.unwrap()(promoItem);
        var $99 = {};
        for (var $100 in v) {
            if ({}.hasOwnProperty.call(v, $100)) {
                $99[$100] = v[$100];
            };
        };
        $99.selection = oldenUserEnabledSelectionStatus(selection(promoItem));
        return $99;
    })());
};
var selectionAge = function ($235) {
    return selectionStatusAge(selection($235));
};
var setActive = function (active) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $102 = {};
            for (var $103 in v) {
                if ({}.hasOwnProperty.call(v, $103)) {
                    $102[$103] = v[$103];
                };
            };
            $102.active = active;
            return $102;
        })());
    };
};
var setInputCoupon = function (coupon) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $105 = {};
            for (var $106 in v) {
                if ({}.hasOwnProperty.call(v, $106)) {
                    $105[$106] = v[$106];
                };
            };
            $105.input = new CouponCodeInput({
                chosenCoupon: coupon
            });
            return $105;
        })());
    };
};
var selectCoupon = function (coupon) {
    return function (promoItem) {
        var $108 = Restaumatic_PromotionsEngine_Promotions_Promotion.isCouponPromotion(promotion(promoItem));
        if ($108) {
            return setInputCoupon(coupon)(promoItem);
        };
        return promoItem;
    };
};
var setInputFreeby = function (freeby) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $109 = {};
            for (var $110 in v) {
                if ({}.hasOwnProperty.call(v, $110)) {
                    $109[$110] = v[$110];
                };
            };
            $109.input = new FreeProductInput({
                selection: freeby
            });
            return $109;
        })());
    };
};
var selectFreeby = function (freeby) {
    return function (promoItem) {
        var $112 = Restaumatic_PromotionsEngine_Promotions_Promotion.isInPromotionFreebies(freeby)(promotion(promoItem));
        if ($112) {
            return setInputFreeby(freeby)(promoItem);
        };
        return promoItem;
    };
};
var setNoInput = function (promoItem) {
    return Data_Newtype.wrap()((function () {
        var v = Data_Newtype.unwrap()(promoItem);
        var $113 = {};
        for (var $114 in v) {
            if ({}.hasOwnProperty.call(v, $114)) {
                $113[$114] = v[$114];
            };
        };
        $113.input = NoInput.value;
        return $113;
    })());
};
var setSelection = function (selectionStatus) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $116 = {};
            for (var $117 in v) {
                if ({}.hasOwnProperty.call(v, $117)) {
                    $116[$117] = v[$117];
                };
            };
            $116.selection = selectionStatus;
            return $116;
        })());
    };
};
var setValue = function (newValue) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $119 = {};
            for (var $120 in v) {
                if ({}.hasOwnProperty.call(v, $120)) {
                    $119[$120] = v[$120];
                };
            };
            $119.value = newValue;
            return $119;
        })());
    };
};
var source = /* #__PURE__ */ (function () {
    var $236 = Data_Newtype.unwrap();
    return function ($237) {
        return (function (v) {
            return v.source;
        })($236($237));
    };
})();
var sourceProductItems = function (item) {
    var v = source(item);
    if (v instanceof NoSource) {
        return [  ];
    };
    if (v instanceof SourceProductItems) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 389, column 3 - line 391, column 58): " + [ v.constructor.name ]);
};
var target = /* #__PURE__ */ (function () {
    var $238 = Data_Newtype.unwrap();
    return function ($239) {
        return (function (v) {
            return v.target;
        })($238($239));
    };
})();
var targetProductItemKeys = function ($240) {
    return productItemKeysInTarget(target($240));
};
var targetContains = function (dictOrd) {
    return function (promoItem) {
        return function (prodKey) {
            return Data_Set.member(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItemKey(dictOrd))(prodKey)(targetProductItemKeys(promoItem));
        };
    };
};
var value = /* #__PURE__ */ (function () {
    var $241 = Data_Newtype.unwrap();
    return function ($242) {
        return (function (v) {
            return v.value;
        })($241($242));
    };
})();
var newtypeCoupon = {
    Coercible0: function () {
        return undefined;
    }
};
var mkUserEnabled = /* #__PURE__ */ (function () {
    return UserEnabled.create;
})();
var mkUserEnabledDefault = /* #__PURE__ */ mkUserEnabled(0);
var mkUserDisabled = /* #__PURE__ */ (function () {
    return UserDisabled.value;
})();
var mkUnassignmentToProduct = /* #__PURE__ */ (function () {
    return UnassignmentToProduct.value;
})();
var mkUnassignmentToCart = /* #__PURE__ */ (function () {
    return UnassignmentToCart.value;
})();
var mkTargetItems = function (dictFoldable) {
    return function (dictOrd) {
        var $243 = Data_Set.fromFoldable(dictFoldable)(Restaumatic_PromotionsEngine_Cart_ProductItem.ordProductItemKey(dictOrd));
        return function ($244) {
            return TargetProductItems.create($243($244));
        };
    };
};
var mkTargetCart = /* #__PURE__ */ (function () {
    return TargetCart.value;
})();
var mkSourceItems = /* #__PURE__ */ (function () {
    return SourceProductItems.create;
})();
var mkPromotionalItem = function (promoItemId) {
    return function (promo) {
        return function (initSelection) {
            return function (initInput) {
                return function (initVal) {
                    return function (initAssignement) {
                        return function (initTarget) {
                            return function (initSource) {
                                return {
                                    promotionalItemId: promoItemId,
                                    promotion: promo,
                                    target: initTarget,
                                    source: initSource,
                                    assignment: initAssignement,
                                    selection: initSelection,
                                    input: initInput,
                                    value: initVal,
                                    active: true
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var mkNoSource = /* #__PURE__ */ (function () {
    return NoSource.value;
})();
var mkNoInput = /* #__PURE__ */ (function () {
    return NoInput.value;
})();
var mkFreeProductInput = function (freeProductChoice) {
    return new FreeProductInput({
        selection: freeProductChoice
    });
};
var mkDefaultAssignment = function (promo) {
    var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(promo);
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget) {
        return UnassignmentToCart.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget) {
        return UnassignmentToProduct.value;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 219, column 3 - line 221, column 43): " + [ v.constructor.name ]);
};
var mkCouponInput = function (coupon) {
    return new CouponCodeInput({
        chosenCoupon: coupon
    });
};
var mkAutoEnabled = /* #__PURE__ */ (function () {
    return AutoEnabled.value;
})();
var mkAutoDisabled = /* #__PURE__ */ (function () {
    return AutoDisabled.value;
})();
var mkAssignmentToProduct = /* #__PURE__ */ (function () {
    return AssignmentToProduct.create;
})();
var mkAssignmentToCart = /* #__PURE__ */ (function () {
    return AssignmentToCart.value;
})();
var isUserSelection = function (v) {
    if (v instanceof UserEnabled) {
        return true;
    };
    if (v instanceof UserDisabled) {
        return true;
    };
    return false;
};
var isUserEnabledSelection = function (v) {
    if (v instanceof UserEnabled) {
        return true;
    };
    return false;
};
var isUserDisabledSelection = function (v) {
    if (v instanceof UserDisabled) {
        return true;
    };
    return false;
};
var isTouchedByUser = /* #__PURE__ */ (function () {
    var $245 = Data_Newtype.unwrap();
    return function ($246) {
        return isUserSelection((function (v) {
            return v.selection;
        })($245($246)));
    };
})();
var isProductPromotionalItem = function ($247) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.isProductPromotion(promotion($247));
};
var isEnabledSelection = function (v) {
    if (v instanceof UserEnabled) {
        return true;
    };
    if (v instanceof AutoEnabled) {
        return true;
    };
    return false;
};
var isEnabledByUser = /* #__PURE__ */ (function () {
    var $248 = Data_Newtype.unwrap();
    return function ($249) {
        return isUserEnabledSelection((function (v) {
            return v.selection;
        })($248($249)));
    };
})();
var isEnabled = /* #__PURE__ */ (function () {
    var $250 = Data_Newtype.unwrap();
    return function ($251) {
        return isEnabledSelection((function (v) {
            return v.selection;
        })($250($251)));
    };
})();
var isCartPromotionalItem = function ($252) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.isCartPromotion(promotion($252));
};
var isAutoAssignablePromotionalItem = function ($253) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.isAutoAssignablePromotion(promotion($253));
};
var isActive = /* #__PURE__ */ (function () {
    var $254 = Data_Newtype.unwrap();
    return function ($255) {
        return (function (v) {
            return v.active;
        })($254($255));
    };
})();
var input = /* #__PURE__ */ (function () {
    var $256 = Data_Newtype.unwrap();
    return function ($257) {
        return (function (v) {
            return v.input;
        })($256($257));
    };
})();
var genericSelectionStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AutoEnabled.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return AutoDisabled.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new UserEnabled(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return UserDisabled.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 165, column 1 - line 165, column 68): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AutoEnabled) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof AutoDisabled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof UserEnabled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof UserDisabled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 165, column 1 - line 165, column 68): " + [ x.constructor.name ]);
    }
};
var showSelectionStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSelectionStatus)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoEnabled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoDisabled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "UserEnabled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "UserDisabled";
        }
    })))))
};
var genericPromotionalItemTarget = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return TargetCart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new TargetProductItems(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 112, column 1 - line 112, column 84): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof TargetCart) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof TargetProductItems) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 112, column 1 - line 112, column 84): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemTarget = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericPromotionalItemTarget)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "TargetCart";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Set.showSet(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow))))({
            reflectSymbol: function () {
                return "TargetProductItems";
            }
        })))
    };
};
var genericPromotionalItemSource = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NoSource.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new SourceProductItems(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 124, column 1 - line 124, column 84): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NoSource) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof SourceProductItems) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 124, column 1 - line 124, column 84): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemSource = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericPromotionalItemSource)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "NoSource";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showArray(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow))))({
            reflectSymbol: function () {
                return "SourceProductItems";
            }
        })))
    };
};
var genericPromotionalItemInput = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new FreeProductInput(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new CouponCodeInput(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return NoInput.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 83, column 1 - line 83, column 78): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof FreeProductInput) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CouponCodeInput) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof NoInput) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 83, column 1 - line 83, column 78): " + [ x.constructor.name ]);
    }
};
var genericPromotionalItemAssignment = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AssignmentToCart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return UnassignmentToCart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new AssignmentToProduct(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return UnassignmentToProduct.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 143, column 1 - line 143, column 92): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AssignmentToCart) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof UnassignmentToCart) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof AssignmentToProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof UnassignmentToProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 143, column 1 - line 143, column 92): " + [ x.constructor.name ]);
    }
};
var showPromotionalItemAssignment = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericPromotionalItemAssignment)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "AssignmentToCart";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "UnassignmentToCart";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow)))({
            reflectSymbol: function () {
                return "AssignmentToProduct";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "UnassignmentToProduct";
            }
        })))))
    };
};
var genericPromotionalItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericDiscount = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Percentage(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Price(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 27, column 1 - line 27, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Percentage) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Price) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 27, column 1 - line 27, column 54): " + [ x.constructor.name ]);
    }
};
var showDiscount = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDiscount)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showNumber))({
        reflectSymbol: function () {
            return "Percentage";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Money_Rounded.showMoney))({
        reflectSymbol: function () {
            return "Price";
        }
    })))
};
var udecodeDiscount = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericDiscount)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Percentage";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeNumber1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Price";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Data_Money_Rounded.udecodeMoney)))))(Unscramble_Generic.defaultOptions)
};
var udecodeCoupon = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "code";
    }
})(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "discount";
    }
})(udecodeDiscount)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "name";
    }
})(Unscramble.decodeString1)(Unscramble.decodeRecordNil))));
var udecodePromotionalItemInput = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionalItemInput)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "selection";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CouponCodeInput";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "chosenCoupon";
        }
    })(udecodeCoupon)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "NoInput";
        }
    })))))(Unscramble_Generic.defaultOptions)
};
var genericCoupon = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCoupon = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCoupon)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "discount";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(showDiscount))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "Coupon";
        }
    }))
};
var showPromotionalItemInput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionalItemInput)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "selection";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))))({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "chosenCoupon";
        }
    })(Data_Show.showRecordFieldsNil)(showCoupon))))({
        reflectSymbol: function () {
            return "CouponCodeInput";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NoInput";
        }
    }))))
};
var showPromotionalItem = function (dictShow) {
    return {
        show: function (item) {
            var rawItem = Data_Newtype.unwrap()(item);
            return "PromotionalItem" + ("\x0a{ promotionalItemId: " + (Data_Show.show(Data_Show.showInt)(rawItem.promotionalItemId) + ("\x0a, promotion:         " + (Data_Show.show(Restaumatic_PromotionsEngine_Promotions_Promotion.showPromotion)(rawItem.promotion) + ("\x0a, target:            " + (Data_Show.show(showPromotionalItemTarget(dictShow))(rawItem.target) + ("\x0a, source:            " + (Data_Show.show(showPromotionalItemSource(dictShow))(rawItem.source) + ("\x0a, assignment:        " + (Data_Show.show(showPromotionalItemAssignment(dictShow))(rawItem.assignment) + ("\x0a, selection:         " + (Data_Show.show(showSelectionStatus)(rawItem.selection) + ("\x0a, input:             " + (Data_Show.show(showPromotionalItemInput)(rawItem.input) + ("\x0a, value:             " + (Data_Show.show(Data_Maybe.showMaybe(Data_Money_Rounded.showMoney))(rawItem.value) + ("\x0a, active:            " + (Data_Show.show(Data_Show.showBoolean)(rawItem.active) + "\x0a}"))))))))))))))))));
        }
    };
};
var functorPromotionalItemSource = {
    map: function (f) {
        return function (m) {
            if (m instanceof NoSource) {
                return NoSource.value;
            };
            if (m instanceof SourceProductItems) {
                return new SourceProductItems(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Restaumatic_PromotionsEngine_Cart_ProductItem.functorProductItemKey)(f))(m.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 123, column 1 - line 123, column 78): " + [ m.constructor.name ]);
        };
    }
};
var functorPromotionalItemAssignment = {
    map: function (f) {
        return function (m) {
            if (m instanceof AssignmentToCart) {
                return AssignmentToCart.value;
            };
            if (m instanceof UnassignmentToCart) {
                return UnassignmentToCart.value;
            };
            if (m instanceof AssignmentToProduct) {
                return new AssignmentToProduct(Data_Functor.map(Restaumatic_PromotionsEngine_Cart_ProductItem.functorProductItemKey)(f)(m.value0));
            };
            if (m instanceof UnassignmentToProduct) {
                return UnassignmentToProduct.value;
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 144, column 1 - line 144, column 86): " + [ m.constructor.name ]);
        };
    }
};
var forceSetAssignment = function (assignementStatus) {
    return function (promoItem) {
        return Data_Newtype.wrap()((function () {
            var v = Data_Newtype.unwrap()(promoItem);
            var $189 = {};
            for (var $190 in v) {
                if ({}.hasOwnProperty.call(v, $190)) {
                    $189[$190] = v[$190];
                };
            };
            $189.assignment = assignementStatus;
            return $189;
        })());
    };
};
var setAssignment = function (dictOrd) {
    return function (ass) {
        return function (promoItem) {
            var tgt = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(promotion(promoItem));
            if (ass instanceof AssignmentToCart && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget.value)) {
                return forceSetAssignment(ass)(promoItem);
            };
            if (ass instanceof UnassignmentToCart && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget.value)) {
                return forceSetAssignment(ass)(promoItem);
            };
            if (ass instanceof AssignmentToProduct && (Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget.value) && targetContains(dictOrd)(promoItem)(ass.value0))) {
                return forceSetAssignment(ass)(promoItem);
            };
            if (ass instanceof UnassignmentToProduct && Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionTarget)(tgt)(Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget.value)) {
                return forceSetAssignment(ass)(promoItem);
            };
            return promoItem;
        };
    };
};
var unassign = function (dictOrd) {
    return function (promoItem) {
        var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(promotion(promoItem));
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget) {
            return setAssignment(dictOrd)(mkUnassignmentToCart)(promoItem);
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget) {
            return setAssignment(dictOrd)(mkUnassignmentToProduct)(promoItem);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 425, column 3 - line 427, column 69): " + [ v.constructor.name ]);
    };
};
var excludeItemsFrom = function (subset) {
    return Data_Array.filter(function (item) {
        return Data_Foldable.notElem(Data_Foldable.foldableArray)(Data_Eq.eqInt)(promotionalItemId(item))(Data_Functor.map(Data_Functor.functorArray)(promotionalItemId)(subset));
    });
};
var eqSelectionStatus = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSelectionStatus)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqInt)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))))
};
var eqPromotionalItemTarget = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItemTarget)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Set.eqSet(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))))
    };
};
var eqPromotionalItemSource = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItemSource)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqArray(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))))
    };
};
var eqPromotionalItemAssignment = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItemAssignment)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))))
    };
};
var eqDiscount = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericDiscount)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqNumber)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Money_Rounded.eqMoney))))
};
var ordDiscount = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericDiscount)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Data_Ord.ordNumber)))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Data_Money_Rounded.ordMoney)))),
    Eq0: function () {
        return eqDiscount;
    }
};
var eqCoupon = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericCoupon)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "discount";
        }
    })(eqDiscount))()({
        reflectSymbol: function () {
            return "code";
        }
    })(Data_Eq.eqString)))))
};
var eqPromotionalItemInput = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionalItemInput)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "selection";
        }
    })(Data_Eq.eqString)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "chosenCoupon";
        }
    })(eqCoupon)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var eqPromotionalItem = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericPromotionalItem)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "value";
            }
        })(Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney)))()({
            reflectSymbol: function () {
                return "target";
            }
        })(eqPromotionalItemTarget(dictEq)))()({
            reflectSymbol: function () {
                return "source";
            }
        })(eqPromotionalItemSource(dictEq)))()({
            reflectSymbol: function () {
                return "selection";
            }
        })(eqSelectionStatus))()({
            reflectSymbol: function () {
                return "promotionalItemId";
            }
        })(Data_Eq.eqInt))()({
            reflectSymbol: function () {
                return "promotion";
            }
        })(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotion))()({
            reflectSymbol: function () {
                return "input";
            }
        })(eqPromotionalItemInput))()({
            reflectSymbol: function () {
                return "assignment";
            }
        })(eqPromotionalItemAssignment(dictEq)))()({
            reflectSymbol: function () {
                return "active";
            }
        })(Data_Eq.eqBoolean)))))
    };
};
var ordPromotionalItem = function (dictEq) {
    return {
        compare: function (a) {
            return function (b) {
                return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidOrdering)([ Data_Ord.compare(Restaumatic_PromotionsEngine_Promotions_Promotion.ordPromotion)(promotion(a))(promotion(b)), Data_Ord.compare(Data_Ord.ordInt)(promotionalItemId(a))(promotionalItemId(b)) ]);
            };
        },
        Eq0: function () {
            return eqPromotionalItem(dictEq);
        }
    };
};
var encodeSelectionStatus = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericSelectionStatus)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AutoEnabled";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AutoDisabled";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UserEnabled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UserDisabled";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
};
var encodePromotionalItemSource = function (dictEncode) {
    return {
        encode: Foreign_Encoding.defaultEncode(genericPromotionalItemSource)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "NoSource";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "SourceProductItems";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(dictEncode))))))
    };
};
var encodePromotionalItemAssignment = function (dictEncode) {
    return {
        encode: Foreign_Encoding.defaultEncode(genericPromotionalItemAssignment)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToCart";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToCart";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToProduct";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToProduct";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
    };
};
var encodeDiscount = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericDiscount)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Percentage";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))))
};
var encodeCoupon = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCoupon)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Coupon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "discount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDiscount)))({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodePromotionalItemInput = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CouponCodeInput";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "chosenCoupon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCoupon))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "NoInput";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))
};
var defaultInput = function (promo) {
    var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionPrize(promo);
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.Freeby) {
        var name = Restaumatic_PromotionsEngine_Promotions_Promotion.getFirstPromotionFreebyName(promo);
        return new FreeProductInput({
            selection: Data_Maybe.fromMaybe("")(name)
        });
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.PercentageDiscount) {
        return NoInput.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.PriceDiscount) {
        return NoInput.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CouponValue) {
        return NoInput.value;
    };
    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.TextInformation) {
        return NoInput.value;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 433, column 3 - line 438, column 31): " + [ v.constructor.name ]);
};
var mkDefaultPromotionalItem = function (promoItemId) {
    return function (promo) {
        return function (assignmentMode) {
            var initialAssignment = (function () {
                var $199 = Data_Eq.eq(Restaumatic_PromotionsEngine_Cart_CartParams.eqAssignmentMode)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_CartParams.AutoAssign.value);
                if ($199) {
                    return AutoDisabled.value;
                };
                return UserDisabled.value;
            })();
            return mkPromotionalItem(promoItemId)(promo)(initialAssignment)(defaultInput(promo))(Data_Maybe.Nothing.value)(mkDefaultAssignment(promo));
        };
    };
};
var decodeSelectionStatus = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericSelectionStatus)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AutoEnabled";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AutoDisabled";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UserEnabled";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UserDisabled";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))
};
var decodePromotionalItemSource = function (dictDecode) {
    return {
        decode: Foreign_Encoding.defaultDecode(genericPromotionalItemSource)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "NoSource";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "SourceProductItems";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(dictDecode))))(Foreign_Generic_Class.genericCountArgsArgument)))
    };
};
var decodePromotionalItemAssignment = function (dictDecode) {
    return {
        decode: Foreign_Encoding.defaultDecode(genericPromotionalItemAssignment)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToCart";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToCart";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "AssignmentToProduct";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "UnassignmentToProduct";
            }
        })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))
    };
};
var decodeDiscount = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericDiscount)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Percentage";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var decodeCoupon = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCoupon)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Coupon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "discount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDiscount))())({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePromotionalItemInput = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionalItemInput)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FreeProductInput";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "selection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CouponCodeInput";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "chosenCoupon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCoupon))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "NoInput";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))
};
var couponName = /* #__PURE__ */ (function () {
    var $258 = Data_Newtype.unwrap();
    return function ($259) {
        return (function (v) {
            return v.name;
        })($258($259));
    };
})();
var couponDiscount = /* #__PURE__ */ (function () {
    var $260 = Data_Newtype.unwrap();
    return function ($261) {
        return (function (v) {
            return v.discount;
        })($260($261));
    };
})();
var couponCode = /* #__PURE__ */ (function () {
    var $262 = Data_Newtype.unwrap();
    return function ($263) {
        return (function (v) {
            return v.code;
        })($262($263));
    };
})();
var hasRequiredInput = function (item) {
    var v = input(item);
    var v1 = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionPrize(promotion(item));
    if (v1 instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CouponValue && v instanceof CouponCodeInput) {
        return !Data_String_Common["null"](couponCode(v.value0.chosenCoupon));
    };
    if (v1 instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CouponValue) {
        return false;
    };
    return true;
};
var isItemAutoAssigneable = function (item) {
    return isAutoAssignablePromotionalItem(item) && hasRequiredInput(item);
};
var combineableClique = function (promotionalItems) {
    var promotionsClique = Restaumatic_PromotionsEngine_Promotions_Promotion.combineableClique(Data_Functor.map(Data_Functor.functorArray)(promotion)(promotionalItems));
    return Data_Array.filter(function (item) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotion)(promotion(item))(promotionsClique);
    })(promotionalItems);
};
var chosenCoupon = function (promoItem) {
    var v = promotionalItemInput(promoItem);
    if (v instanceof CouponCodeInput) {
        return new Data_Maybe.Just(v.value0.chosenCoupon);
    };
    return Data_Maybe.Nothing.value;
};
var changeInput = function (dictEq) {
    return function (promotionalItem) {
        return function (newInput) {
            if (newInput instanceof FreeProductInput) {
                return selectFreeby(newInput.value0.selection)(promotionalItem);
            };
            if (newInput instanceof CouponCodeInput) {
                return selectCoupon(newInput.value0.chosenCoupon)(promotionalItem);
            };
            if (newInput instanceof NoInput) {
                return setNoInput(promotionalItem);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 461, column 3 - line 464, column 42): " + [ newInput.constructor.name ]);
        };
    };
};
var canCombineWithAllOthers = function (promotionalItem) {
    return function (promotionalItems) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.canCombineWithAllOthers(promotion(promotionalItem))(Data_Functor.map(Data_Functor.functorArray)(promotion)(promotionalItems));
    };
};
var canCombineWithAll = function (promotionalItem) {
    return function (promotionalItems) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.canCombineWithAll(promotion(promotionalItem))(Data_Functor.map(Data_Functor.functorArray)(promotion)(promotionalItems));
    };
};
var partitionCombineable = function (promotionalItems) {
    var v = Restaumatic_PromotionsEngine_Common.partitionTuple(isEnabled)(promotionalItems);
    var v1 = Restaumatic_PromotionsEngine_Common.partitionTuple(function (v2) {
        return canCombineWithAll(v2)(v.value0);
    })(v.value1);
    return new Data_Tuple.Tuple(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.value0)(v1.value0), v1.value1);
};
var canCombineWith = function (otherPromotionalItem) {
    return function (promotionalItem) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.canCombineWith(promotion(otherPromotionalItem))(promotion(promotionalItem));
    };
};
var assignmentProductItemKey = function (assign) {
    if (assign instanceof AssignmentToProduct) {
        return new Data_Maybe.Just(assign.value0);
    };
    return Data_Maybe.Nothing.value;
};
var assignment = /* #__PURE__ */ (function () {
    var $264 = Data_Newtype.unwrap();
    return function ($265) {
        return (function (v) {
            return v.assignment;
        })($264($265));
    };
})();
var resetPromotionalItem = function (dictOrd) {
    return function (item) {
        var disabledItem = (function () {
            var $219 = isTouchedByUser(item);
            if ($219) {
                return setSelection(UserDisabled.value)(item);
            };
            return setSelection(AutoDisabled.value)(item);
        })();
        var unassignedDisabledItem = (function () {
            var v = assignment(disabledItem);
            if (v instanceof AssignmentToCart) {
                return setAssignment(dictOrd)(UnassignmentToCart.value)(disabledItem);
            };
            if (v instanceof AssignmentToProduct) {
                return setAssignment(dictOrd)(UnassignmentToProduct.value)(disabledItem);
            };
            return disabledItem;
        })();
        return unassignedDisabledItem;
    };
};
var resetPromotionalItems = function (dictOrd) {
    return Data_Functor.map(Data_Functor.functorArray)(resetPromotionalItem(dictOrd));
};
var assignedProductItemKey = function ($266) {
    return assignmentProductItemKey(assignment($266));
};
var allocatedProductItemKeys = function (item) {
    var v = assignmentProductItemKey(assignment(item));
    if (v instanceof Data_Maybe.Just) {
        return Data_Array.cons(v.value0)(sourceProductItems(item));
    };
    if (v instanceof Data_Maybe.Nothing) {
        return [  ];
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.PromotionalItem (line 488, column 3 - line 490, column 18): " + [ v.constructor.name ]);
};
var allCombineable = function (promotionalItem) {
    return Data_Array.filter(canCombineWith(promotionalItem));
};
export {
    Percentage,
    Price,
    Coupon,
    couponCode,
    couponDiscount,
    couponName,
    FreeProductInput,
    CouponCodeInput,
    NoInput,
    mkFreeProductInput,
    mkCouponInput,
    mkNoInput,
    TargetCart,
    TargetProductItems,
    NoSource,
    SourceProductItems,
    AssignmentToCart,
    UnassignmentToCart,
    AssignmentToProduct,
    UnassignmentToProduct,
    AutoEnabled,
    AutoDisabled,
    UserEnabled,
    UserDisabled,
    mkTargetCart,
    mkTargetItems,
    mkNoSource,
    mkSourceItems,
    mkAssignmentToCart,
    mkUnassignmentToCart,
    mkAssignmentToProduct,
    mkUnassignmentToProduct,
    mkAutoEnabled,
    mkAutoDisabled,
    mkUserEnabled,
    mkUserEnabledDefault,
    mkUserDisabled,
    mkDefaultAssignment,
    productItemKeysInTarget,
    oldenUserEnabledSelectionStatus,
    isUserSelection,
    isUserEnabledSelection,
    isUserDisabledSelection,
    isEnabledSelection,
    selectionStatusAge,
    assignmentProductItemKey,
    PromotionalItem,
    mkPromotionalItem,
    mkDefaultPromotionalItem,
    setSelection,
    oldenUserSelection,
    forceSetAssignment,
    setAssignment,
    setValue,
    promotion,
    promotions,
    promotionalItemId,
    promotionId,
    target,
    source,
    sourceProductItems,
    input,
    value,
    isActive,
    assignment,
    selection,
    selectionAge,
    promotionalItemInput,
    promotionalItemValue,
    targetProductItemKeys,
    targetContains,
    unassign,
    defaultInput,
    setInputFreeby,
    setInputCoupon,
    setNoInput,
    selectFreeby,
    selectCoupon,
    changeInput,
    selectedFreeby,
    chosenCoupon,
    setActive,
    assignedProductItemKey,
    allocatedProductItemKeys,
    resetPromotionalItems,
    resetPromotionalItem,
    canCombineWith,
    canCombineWithAll,
    canCombineWithAllOthers,
    allCombineable,
    combineableClique,
    excludeItemsFrom,
    partitionCombineable,
    isCartPromotionalItem,
    isProductPromotionalItem,
    isAutoAssignablePromotionalItem,
    isTouchedByUser,
    isEnabledByUser,
    isEnabled,
    isItemAutoAssigneable,
    hasRequiredInput,
    genericDiscount,
    showDiscount,
    eqDiscount,
    ordDiscount,
    encodeDiscount,
    decodeDiscount,
    udecodeDiscount,
    newtypeCoupon,
    genericCoupon,
    showCoupon,
    eqCoupon,
    encodeCoupon,
    decodeCoupon,
    udecodeCoupon,
    genericPromotionalItemInput,
    showPromotionalItemInput,
    eqPromotionalItemInput,
    encodePromotionalItemInput,
    decodePromotionalItemInput,
    udecodePromotionalItemInput,
    genericPromotionalItemTarget,
    showPromotionalItemTarget,
    eqPromotionalItemTarget,
    functorPromotionalItemSource,
    genericPromotionalItemSource,
    showPromotionalItemSource,
    eqPromotionalItemSource,
    encodePromotionalItemSource,
    decodePromotionalItemSource,
    genericPromotionalItemAssignment,
    functorPromotionalItemAssignment,
    showPromotionalItemAssignment,
    eqPromotionalItemAssignment,
    encodePromotionalItemAssignment,
    decodePromotionalItemAssignment,
    genericSelectionStatus,
    showSelectionStatus,
    eqSelectionStatus,
    encodeSelectionStatus,
    decodeSelectionStatus,
    newtypePromotionalItem,
    genericPromotionalItem,
    eqPromotionalItem,
    ordPromotionalItem,
    showPromotionalItem
};
//# sourceMappingURL=index.js.map
